import { Collapse, IconProps } from '@mui/material';
import { useLocation } from '@tanstack/react-router';

import { useSidebar } from '../../../providers/SidebarContextProvider';
import SidebarLink, { SidebarLinkItem } from './SidebarLink';
import { SidebarMinimizedLink } from './SidebarMinimizedLink';

type Props = {
  text: string;
  icon: React.FC<IconProps>;
  links: Omit<SidebarLinkItem, 'icon'>[];
  route: string;
  testId?: string;
};

export default function SidebarNestedLinks({ icon: Icon, text, links, route, testId }: Props) {
  const pathname = useLocation({ select: (location) => location.pathname });
  const { sidebarOpen } = useSidebar();
  const current = pathname.split('/')[1] === route;
  const [accordionOpen, setAccordionOpen] = React.useState(current);

  if (!sidebarOpen) {
    return <SidebarMinimizedLink Icon={Icon} title={text} links={links} current={current} data-testid={testId} />;
  }

  return (
    <div className="w-full">
      <SidebarLink
        parent
        current={current}
        text={text}
        icon={Icon}
        onClick={() => setAccordionOpen(!accordionOpen)}
        data-testid={testId}
      />
      <Collapse in={accordionOpen} timeout="auto" unmountOnExit>
        <div className="py-1">
          {links.map((link) => (
            <div key={link.text} className="px-2">
              <SidebarLink key={link.text} nested {...link} />
            </div>
          ))}
        </div>
      </Collapse>
    </div>
  );
}
